import { combineReducers } from "redux";
import App from "./app/reducers";
import Collections from "./collections/reducers";
// import Events from "./events/reducers";
// import Calendar from "./calendar/reducers";
// import Search from "./search/reducers";
// import Tasks from "./tasks/reducers";
// import Activity from "./activity/reducers";
// import Documents from "./documents/reducers";
import Background from "./background/reducers";
// import Users from "./users/reducers";
import Voice from "./voice/reducers";
// import Timeline from "./timeline/reducers";
// import Content from "./content/reducers";
import AI from "./ai/reducers";
import Lines from "./lines/reducers";

/**
 * @typedef {object} app.State
 * @memberof app
 * @property {State.App} App
 * @property {State.Calendar} Calendar
 // * @property {State.Tasks} Tasks
 * @property {State.Background} Background
 * @property {State.Voice} Voice
 * @property {State.AI} AI
 * @property {State.Apps} Apps
 */
const collections = {
  // Events,
  // Calendar,
  // Search,
  // Tasks,
  // Activity,
  // Content,
  // Documents,
  // Users,
  // Timeline,
  App,
  Lines,
  Collections,
  Background,
  Voice,
  AI,
};
export default combineReducers(collections);
